export interface BatteryAnomalySummary {
  installationId: number;
  lastDetectedAt: string;
  lastVoltage: number;
  lastBattery: string;
  count: number;
}

export interface BatteryAnomalyLogEntry {
  id: number;
  installationId: number;
  batteryLabel: string;
  detectedAt: string;
  date: string;
  dateHour: string;
  voltage: number;
  soc: number;
  createdAt: string;
}

export const VOLTAGE_ANOMALY_PRODUCTS = new Set<number>([2, 5]);
